<template>
  <div
    @click="$emit('click')"
    class="default-consent-wrapper"
    :class="{ 'consent-entity-border': !isDetailPage }"
  >
    <div style="display: flex; justify-content: space-between">
      <div class="cell-header single-line-text" :class="{ 'cell-header-detail': isDetailPage }">
          {{ title }}
      </div>
      </div>
      <div class="date-status-wrapper">
        <div class="consent-status" :style="styleColor">
          {{ status }}
        </div>
        <div style="width:auto; flex-grow: 1; order: 2;" > </div>
        <div class="cell-subtext">{{ date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsentEntity',
  props: {
    date: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    isDetailPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
      styleColor() {
        return (this.status === 'accepted' || this.status === 'Completed') ? 'color: #128279; background: #ECF8F7;' : 'color: #323336; background: #E5E6EE;'
      }
  }
}
</script>

<style scoped>
.consent-entity-border {
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 16px;
}

.default-consent-wrapper:hover{
  background-color: #F8F8FD;
}

.default-consent-wrapper {
  background: #fff;
  border: 1px solid #C9CBD5;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  margin: 16px 0;
  display: flex;
  flex-direction: column;
}
.date-status-wrapper {
  display: flex;
  margin-top: 8px;
}

.cell-header {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #161616;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.cell-header-detail {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #171717;
  letter-spacing: -0.5px;
}

.cell-subtext {
  font-style: normal;
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: #565963;
  text-transform: uppercase;
  color: #4f4f4f;
  margin-right: 10px;
  align-self: center;
  order: 2;
  flex-grow: 0;
}

.consent-status {
  border-radius: 22px;
  font-size: 14px;
  padding: 4px 16px;
  width: fit-content;
  text-transform: capitalize;
  align-items: flex-start;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

</style>
